export default {
  primary     : "#ff4d4f",
  primaryDark : "#e05c04",
  primaryLight: "#ff7d26",
  green       : "#77C454",
  pink        : "#FF788E",
  pinkLight   : "#988CCD"
};